import { useTranslations } from "next-intl";
import type { CSSProperties, ReactNode } from "react";
import { T } from "./pricing-shared";
import {
  SUPPORT_FEE_DISPLAY_TIERS,
  type SupportFeeDisplayTier,
} from "./pricing-support-fee";

const GRID: CSSProperties = {
  display: "grid",
  columnGap: 28,
  width: "100%",
  maxWidth: 720,
  border: "1px solid rgba(11,15,25,0.10)",
  borderRadius: 13,
  background: "#FAFAFA",
};

const CELL: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  minHeight: 44,
};

const ROW_LINE = "1px solid rgba(11,15,25,0.08)";

function TierCell({
  tier,
  firstRow,
}: {
  readonly tier: SupportFeeDisplayTier;
  readonly firstRow: boolean;
}): ReactNode {
  const t = useTranslations("public.pricingSupportFeeTiers");
  return (
    <div style={{ ...CELL, borderTop: firstRow ? "none" : ROW_LINE }}>
      <span
        style={{
          fontFamily: T.sans,
          fontSize: 14,
          lineHeight: 1.35,
          color: "#575B63",
        }}
      >
        {t(tier.labelKey)}
      </span>
      <span
        style={{
          fontFamily: T.sans,
          fontSize: 14.5,
          fontWeight: 700,
          color: tier.waived ? T.accent : T.ink,
          flex: "none",
          textAlign: "right",
        }}
      >
        {tier.waived
          ? t("entfaellt0", { amount: tier.amount })
          : t("euroProMonat", { amount: tier.amount })}
      </span>
    </div>
  );
}

/** Grundgebühr table: 2×2 on desktop, one column when `compact`. */
export function PricingSupportFeeTiers({
  compact,
}: {
  readonly compact: boolean;
}): ReactNode {
  const rows = compact
    ? SUPPORT_FEE_DISPLAY_TIERS.length
    : Math.ceil(SUPPORT_FEE_DISPLAY_TIERS.length / 2);
  return (
    <div
      style={{
        ...GRID,
        gridTemplateColumns: compact ? "1fr" : "1fr 1fr",
        gridTemplateRows: `repeat(${rows}, auto)`,
        gridAutoFlow: "column",
        padding: compact ? "2px 16px" : "2px 22px",
      }}
    >
      {SUPPORT_FEE_DISPLAY_TIERS.map((tier, i) => (
        <TierCell key={tier.labelKey} tier={tier} firstRow={i % rows === 0} />
      ))}
    </div>
  );
}
